import { EmployerSelectController } from "../../controllers";
import { ApiCrudObjectControllerBindings } from "../../controllers/bases";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows employer selection
 * @example
 * ```html
 * <salaxy-employer-select model="" on-employer-select=""></salaxy-employer-select>
 * ```
 */
export class EmployerSelect extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
   public bindings = (new class extends ApiCrudObjectControllerBindings {

     /** Selected items for the case where the list is used as a select list (as opposed to link list). */
     selectedItems = "<";

     /** Current list of items. */
     items = "<";
    /**
     * Function that is called when user selects an item in the list.
     * Note that the event is called only in the selection. Not when there is a link to details view in a link list.
     * Function has the following locals: value: true/false, item: the last selected/unselected item.
     * @example <salaxy-employer-select on-employer-select="$ctrl.updateFromEmployment(item.id)"></salaxy-employer-select>
     */
      onEmployerSelect = "&";

    }());

    /** Uses the CalcSharingController */
    public controller = EmployerSelectController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/personal/EmployerSelect.html";

}
